import Context from "../../context/Context";
import Dataset from "./Dataset";
import FieldNames from "./FieldNames";
import * as aiimUtil from "../util/aiimUtil";
import * as searchUtil from "../util/searchUtil";

export default class People extends Dataset {

  emailField = FieldNames.PEOPLE_EMAIL;
  fullNameField = FieldNames.PEOPLE_FULLNAME;
  unitIDField = FieldNames.PEOPLE_UNIT_ID;
  type = "feature";

  checkSchema() {
    const promise = new Promise((resolve,reject) => {
      if (this.layer2D) {
        const layer = this.layer2D;
        layer.when(() => {
          this.checkFieldNameProperty("emailField",layer.fields);
          this.checkFieldNameProperty("fullNameField",layer.fields);
          this.checkFieldNameProperty("unitIDField",layer.fields);
          resolve();
        }).catch(ex => {
          console.log("Failed to load dataset layer:",layer.title);
          console.error(ex);
          resolve();
        });
      } else {
        resolve();
      }
    });
    return promise;
  }

  getSource() {
    return Context.getInstance().aiim.datasets.categories.findSourceByKey("People"); // TODO
  }

  getUnitID(peopleFeature) {
    return aiimUtil.getAttributeValue(peopleFeature.attributes,this.unitIDField);
  }

  isPeopleLayer(layer,fields) {
    if (fields) {
      let count = 0;
      const matched = fields.some((field) => {
        const lc = field.name.toLowerCase();
        if (lc === FieldNames.PEOPLE_FULLNAME.toLowerCase() ||
            lc === FieldNames.PEOPLE_EMAIL.toLowerCase()) {
          count++;
          if (count >= 2) return true;
        }
        return false;
      });
      return matched;
    }
    return false;
  }

  queryAppUser() {
    const promise = new Promise((resolve,reject) => {
      const url = this.url;
      const emailField = this.emailField;
      const fullNameField = this.fullNameField;
      const email = Context.getInstance().user.getEmail();
      const fullName = Context.getInstance().user.getFullName();
      const source = this.getSource();
      searchUtil.queryFieldValue(source,url,emailField,email).then(result => {
        if (result && result.features && result.features.length === 1) {
          return result;
        } else {
          return searchUtil.queryFieldValue(source,url,fullNameField,fullName);
        }
      }).then(results => {
        resolve(results);
      }).catch(ex => {
        reject(ex);
      });
    });
    return promise;
  }

}
